/**
 * Sentinel prefix marking a synthetic "keep going" user message the client
 * injects to auto-continue a turn that hit its step budget. The LLM reads the
 * full prompt as a normal nudge; the client bubble renderer detects this prefix
 * and hides the message entirely (mirrors the `MENTION_CONTEXT_SENTINEL`
 * pattern) so auto-continuation is invisible to the user.
 *
 * Shared so the server can also recognize (and skip) these hidden nudges — e.g.
 * when picking the user text to base a thread title on.
 */
export const CONTINUATION_SENTINEL = "<ContinueTurn>";

/** The hidden nudge sent to resume a turn that exhausted its step budget. */
export const CONTINUATION_PROMPT = `${CONTINUATION_SENTINEL} Continue working on the previous request. Pick up exactly where you left off and keep going until the task is complete.`;
